// extracted by mini-css-extract-plugin
export default {"main":"ReferredGenericPage_main__PcRKP","homepage":"ReferredGenericPage_homepage__fN6iJ","header":"ReferredGenericPage_header__H232u","btn":"ReferredGenericPage_btn__5y6+I"};